export type AppEnv = 'local' | 'qa' | 'staging' | 'production';

export const isAppEnv = (value: unknown): value is AppEnv => {
  if (typeof value !== 'string') {
    return false;
  }

  return (
    value === 'local' ||
    value === 'qa' ||
    value === 'staging' ||
    value === 'production'
  );
};
